var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home/Game/Notification/Chat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-662 -1184C-662 -1185.1 -661.105 -1186 -660 -1186H9362C9363.1 -1186 9364 -1185.1 9364 -1184V209C9364 210.105 9363.1 211 9362 211H-660C-661.104 211 -662 210.105 -662 209V-1184Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Home (Top Winner)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -1048,
    width: 390,
    height: 1133,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttont Nevigition"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M-28 9.53674e-07C-28 -6.62742 -22.6274 -12 -16 -12H350C356.627 -12 362 -6.62742 362 0V85H-28V9.53674e-07Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BG",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 812501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.743 17.393C17.0329 17.799 16.9749 18.4368 16.511 18.7268C16.1051 19.0167 15.4672 18.9588 15.1772 18.4948C14.8873 18.0889 14.9453 17.451 15.4092 17.1611C15.8151 16.8711 16.453 16.9871 16.743 17.393Z",
    fill: "#D037FF",
    fillOpacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 812351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-window 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3478 6.18421L13.0977 2.64121C11.8235 1.78171 10.1765 1.78171 8.90225 2.64121L3.653 6.18421C2.618 6.88171 2 8.04346 2 9.29296V16.25C2 18.3177 3.68225 20 5.75 20H16.25C18.3177 20 20 18.3177 20 16.25V9.29296C20 8.04421 19.382 6.88171 18.3478 6.18421ZM14 14C14 14.8272 13.3273 15.5 12.5 15.5H9.5C8.67275 15.5 8 14.8272 8 14V11C8 10.1727 8.67275 9.49996 9.5 9.49996H12.5C13.3273 9.49996 14 10.1727 14 11V14ZM12.5 11L12.5015 14H9.5V11H12.5Z",
    fill: "white"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "M-660 -1185H9362V-1187H-660V-1185ZM9363 -1184V209H9365V-1184H9363ZM9362 210H-660V212H9362V210ZM-661 209V-1184H-663V209H-661ZM-660 210C-660.552 210 -661 209.552 -661 209H-663C-663 210.657 -661.657 212 -660 212V210ZM9363 209C9363 209.552 9362.55 210 9362 210V212C9363.66 212 9365 210.657 9365 209H9363ZM9362 -1185C9362.55 -1185 9363 -1184.55 9363 -1184H9365C9365 -1185.66 9363.66 -1187 9362 -1187V-1185ZM-660 -1187C-661.657 -1187 -663 -1185.66 -663 -1184H-661C-661 -1184.55 -660.552 -1185 -660 -1185V-1187Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 167,
    y1: -12,
    x2: 167,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE33E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6905A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -1048,
    width: 390,
    height: 1133,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 97,
    fill: "white",
    transform: "translate(-28 -12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/icon_home_active.c6cd96b52fc83637ba6adf03f3cef794.svg";
export { ForwardRef as ReactComponent };